
export async function createLogsSocketConnection(baseUrl, accessToken, accountsMappingId) {
  return new Promise((resolve, reject) => {
    let connectedInstanceId = undefined;
    let socket = new WebSocket(`${baseUrl}/socket/websocket?vsn=1.0.0`);
    let pingTimer = null;
    let ref = 1;

    let handleMessage = () => {};
    let handleError = () => {};

    const terminate = () => {
      if (pingTimer) clearInterval(pingTimer);
      pingTimer = null;
      handleMessage = () => {};
      handleError = () => {};
      try { socket.close(); } catch {}
    };

    const terminateWithError = e => {
      if (connectedInstanceId) {
        handleError(e);
      } else {
        connectedInstanceId = '???';
        reject(e);
      }
      terminate();
    };

    const handler = {
      getInstanceId() { return connectedInstanceId; },
      terminate() { terminate(); },
      onMessage(handler) { handleMessage = handler; },
      onError(handler) { handleError = handler; }
    };

    socket.onmessage = (m) => {
      const { data } = m || {};
      let message = null;
      try {
        message = JSON.parse(data);
      } catch (e) {
        terminateWithError(new Error(`invalid message:${message}`));
      }

      const {
        event,
        payload
      } = message || {};

      if (event === 'phx_error') terminateWithError(new Error('channel is closed'));

      if (event === 'phx_reply') {
        if (payload && payload.status === 'error') {
          terminateWithError(new Error((payload && payload.response && payload.response.reason) || 'Unknown error'));
        }
      }

      if (event === 'service_allocation_info') {
        connectedInstanceId = (payload && payload.allocation_id_hash) || '???';
        resolve(handler);
      }

      if (event === 'message') {
        handleMessage(payload);
      }
    };

    socket.onopen = () => {
      pingTimer = setInterval(() => {
        socket.send(JSON.stringify({
          topic: 'phoenix',
          event: 'heartbeat',
          payload: {},
          ref: `${ref++}`
        }));
      }, 30000);

      socket.send(JSON.stringify({
        event: 'phx_join',
        topic: `logs:${accountsMappingId}`,
        ref: `${ref++}`,
        payload: {
          pd_oauth_token: accessToken,
        }
      }));
    };

    socket.onerror = (...e) => terminateWithError(e);
    socket.onclose = () => terminateWithError(new Error('socket is closed'));
  });
}
